import { createContext } from "react";
import { View } from "@common/types/views/views";
import { defaultAccrualMatchView } from "./accrualMatchView";

interface AccrualMatchViewContextValue {
    tableView: View;
    setTableView: (view: View) => void;
}

// Kept in its own context (separate from the main AccrualMatchCtx) so that
// high-frequency tableView updates during a column resize only re-render the
// three AccrualMatchTable consumers, not the footer / search / page / drawer
// components that don't care about column sizing.
export const AccrualMatchViewCtx = createContext<AccrualMatchViewContextValue>({
    tableView: defaultAccrualMatchView,
    setTableView: () => {},
});
